import axios from '../../axios';

const path = 'measures';

const service = {
  createMeasurement(data) {
    return axios.request({ method: 'post', url: `${path}`, data });
  },

  createMeasurements(data) {
    return axios.request({ method: 'post', url: `${path}/bulk`, data });
  },

  updateMeasurement(id, data) {
    return axios.request({ method: 'put', url: `${path}/${id}`, data });
  },

  deleteMeasurements(ids) {
    return axios({ method: 'delete', url: `${path}/destroy_bulk/`, data: { ids } });
  },

  fetchMeasurements(params) {
    return axios({ method: 'get', url: `${path}`, params });
  },

  fetchAnimalMeasurements(id, params) {
    return axios({ method: 'get', url: `${path}/${id}`, params });
  },

  fetchMeasurementTypes() {
    return axios({ method: 'get', url: `${path}/types` });
  }
};

export default service;
